export const defer = (task: () => void) => {
	setTimeout(() => {
		task();
	}, 0);
};
